
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('core/buffer_core_imagedata',["require", "exports", './buffer_core'], function(require, exports, buffer_core) {
    

    var BufferCoreImageData = (function (_super) {
        __extends(BufferCoreImageData, _super);
        function BufferCoreImageData(length) {
            _super.call(this);
            this.length = length;
            this.buff = BufferCoreImageData.getCanvasPixelArray(length);
        }
        BufferCoreImageData.getCanvasPixelArray = function (bytes) {
            var ctx = BufferCoreImageData.imageDataFactory;

            if (ctx === undefined) {
                BufferCoreImageData.imageDataFactory = ctx = document.createElement('canvas').getContext('2d');
            }

            if (bytes === 0)
                bytes = 1;
            return ctx.createImageData(Math.ceil(bytes / 4), 1).data;
        };
        BufferCoreImageData.isAvailable = function () {
            return typeof CanvasPixelArray !== 'undefined';
        };

        BufferCoreImageData.prototype.getLength = function () {
            return this.length;
        };
        BufferCoreImageData.prototype.writeUInt8 = function (i, data) {
            this.buff[i] = data;
        };
        BufferCoreImageData.prototype.readUInt8 = function (i) {
            return this.buff[i];
        };
        BufferCoreImageData.prototype.copy = function (start, end) {
            var newBC = new BufferCoreImageData(end - start);
            for (var i = start; i < end; i++) {
                newBC.writeUInt8(i - start, this.buff[i]);
            }
            return newBC;
        };
        return BufferCoreImageData;
    })(buffer_core.BufferCoreCommon);
    exports.BufferCoreImageData = BufferCoreImageData;

    var _ = BufferCoreImageData;
});
//# sourceMappingURL=buffer_core_imagedata.js.map
;